import { Component, ErrorInfo, ReactNode } from 'react';
import { Box, Button, Typography } from '@mui/material';
import mixpanel from 'mixpanel-browser';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

// Sin esto, un error de render (o una pantalla que no se pudo bajar tras un deploy) desmonta
// toda la Academia y el alumno ve una página en blanco. Así ve un aviso con "Recargar"
// y el error queda registrado en Mixpanel para poder arreglarlo.
class AppErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('App render error', error, info.componentStack);
    if (process.env.REACT_APP_MIXPANEL_TOKEN) {
      mixpanel.track('App error', {
        name: error?.name,
        message: error?.message?.slice(0, 300),
        path: window.location.pathname,
        componentStack: info.componentStack?.slice(0, 500),
      });
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box sx={{ minHeight: '100vh', width: '100%', flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 2, px: 3, textAlign: 'center', background: '#f8fafc' }}>
          <Typography sx={{ fontWeight: 800, fontSize: 22, color: '#0f172a' }}>Algo falló al cargar la página</Typography>
          <Typography sx={{ color: '#475569', fontSize: 15, maxWidth: 420 }}>
            Puede pasar justo cuando publicamos una actualización. Recarga y debería volver a funcionar.
          </Typography>
          <Box sx={{ display: 'flex', gap: 1.5, mt: 1, flexWrap: 'wrap', justifyContent: 'center' }}>
            <Button
              variant="contained"
              onClick={() => window.location.reload()}
              sx={{ borderRadius: 999, px: 3, fontWeight: 700, color: '#fff', background: '#4f46e5', '&:hover': { background: '#4338ca', color: '#fff' } }}
            >
              Recargar
            </Button>
            <Button
              variant="outlined"
              onClick={() => window.location.assign('/dashboard/inicio')}
              sx={{ borderRadius: 999, px: 3, fontWeight: 700, color: '#0f172a', borderColor: '#cbd5e1' }}
            >
              Ir al inicio
            </Button>
          </Box>
        </Box>
      );
    }
    return this.props.children;
  }
}

export default AppErrorBoundary;
